<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已显示全部"
      @load="getList(true)"
    >
      <div v-for="item in tableData" :key="item.id" class="detail-card">
        <!-- 第一行：变动时间、业务类型 -->
        <div class="card-row top">
          <span class="time">{{ item.createTime || "-" }}</span>
          <van-tag plain type="primary">{{ item.bizTypeName || "-" }}</van-tag>
        </div>
        <!-- 第二行：grid 布局 变动前库存、变动值、变动后库存 -->
        <div class="card-grid">
          <div class="grid-item">
            <div class="grid-label">变动前库存</div>
            <div class="grid-value">{{ item.oriStockNum ?? "-" }}</div>
          </div>
          <div class="grid-item">
            <div class="grid-label">变动值</div>
            <div class="grid-value" :class="getChangeClass(item.stockNum)">
              {{ formatChangeValue(item.stockNum) }}
            </div>
          </div>
          <div class="grid-item">
            <div class="grid-label">变动后库存</div>
            <div class="grid-value">{{ item.curStockNum ?? "-" }}</div>
          </div>
        </div>
      </div>
    </van-list>

    <!-- 修改弹窗 -->
    <van-popup
      v-model:show="modifyVisible"
      position="bottom"
      round
      close-on-click-overlay
    >
      <div class="modify-content">
        <div class="modify-title">修改批次信息</div>
        <van-cell-group inset>
          <van-field
            v-model="modifyForm.productionDate"
            label="生产日期"
            readonly
            placeholder="请选择"
            inputmode="none"
            @click="openDatePicker"
          />
          <van-field
            v-model="modifyForm.shelfLife"
            label="保质期天数"
            type="digit"
            placeholder="请输入"
          />
        </van-cell-group>
        <div class="modify-actions">
          <van-button block @click="modifyVisible = false">取消</van-button>
          <van-button
            block
            type="primary"
            :loading="modifyLoading"
            @click="confirmModify"
            >确定</van-button
          >
        </div>
      </div>
    </van-popup>

    <DateTimePicker
      :showPicker="showDatePicker"
      @confirm="onDateConfirm"
      @cancel="showDatePicker = false"
    />
  </div>
</template>
<script>
import { queryDetailList, modifyLot } from "@/service/api/stock/lot";
import DateTimePicker from "@/components/dateTimePicker";
import { Toast } from "vant";

export default {
  name: "StockLotDetail",
  components: { DateTimePicker },
  data() {
    return {
      lotId: this.$route.params.lotId || "",
      productId: this.$route.query.productId || "",
      productName: this.$route.query.productName || "",
      loading: false,
      finished: false,
      tableData: [],
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      // 修改弹窗
      modifyVisible: false,
      modifyLoading: false,
      modifyForm: {
        id: "",
        productionDate: "",
        shelfLife: "",
      },
      showDatePicker: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = true;
      const params = {
        lotId: this.lotId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      queryDetailList(params)
        .then((res) => {
          this.tableData = load
            ? this.tableData.concat(res.data.datas || [])
            : res.data.datas || [];
          this.loading = false;
          this.totalPage = res.data.totalPage || 1;
          if (this.pageIndex >= this.totalPage) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
    // 打开修改弹窗（从批次列表页调用）
    openModify(item) {
      this.modifyForm.id = item.id;
      this.modifyForm.productionDate = item.productionDate || "";
      this.modifyForm.shelfLife = item.shelfLife != null ? String(item.shelfLife) : "";
      this.modifyVisible = true;
    },
    openDatePicker() {
      this.showDatePicker = true;
    },
    onDateConfirm(value) {
      this.modifyForm.productionDate = value ? value.split(" ")[0] : "";
      this.showDatePicker = false;
    },
    confirmModify() {
      if (!this.modifyForm.productionDate) {
        Toast.fail("请选择生产日期");
        return;
      }
      if (!this.modifyForm.shelfLife) {
        Toast.fail("请输入保质期天数");
        return;
      }
      this.modifyLoading = true;
      modifyLot({
        id: this.modifyForm.id,
        productionDate: this.modifyForm.productionDate,
        shelfLife: this.modifyForm.shelfLife,
      })
        .then((res) => {
          Toast.success(res.msg || "修改成功");
          this.modifyVisible = false;
          this.$emit("modify-success");
        })
        .finally(() => {
          this.modifyLoading = false;
        });
    },
    // 变动值正负显示
    formatChangeValue(val) {
      if (val == null) return "-";
      return Number(val) > 0 ? "+" + val : String(val);
    },
    getChangeClass(val) {
      if (val == null) return "";
      return Number(val) > 0 ? "positive" : "negative";
    },
  },
};
</script>
<style lang="less" scoped>
.detail-card {
  background: #fff;
  margin: 8px 10px;
  padding: 12px;
  border-radius: 8px;

  .card-row {
    display: flex;
    align-items: center;
    font-size: 13px;

    &.top {
      justify-content: space-between;
      border-bottom: 1px solid #f4f4f4;
      padding-bottom: 10px;

      .time {
        font-size: 14px;
        font-weight: 500;
        color: #333;
      }
    }
  }

  .card-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 0;
    margin-top: 10px;

    .grid-item {
      text-align: center;

      &:not(:last-child) {
        border-right: 1px solid #f4f4f4;
      }

      .grid-label {
        font-size: 12px;
        color: #999;
        margin-bottom: 6px;
      }

      .grid-value {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }

      .positive {
        color: #07c160;
      }

      .negative {
        color: #ee0a24;
      }
    }
  }
}

.modify-content {
  padding: 15px;

  .modify-title {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 15px;
  }

  .modify-actions {
    display: flex;
    gap: 10px;
    margin-top: 15px;
  }
}
</style>
